module.exports = __webpack_public_path__ + "static/media/icon_close.01f214a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon_close.svg
// module id = 1859
// module chunks = 0